import Table from "@bmi-digital/components/table";
import { replaceSpaces } from "@bmi-digital/components/utils";
import React from "react";
import type { Feature } from "@bmi/firestore-types";
import { FeatureValue } from "./styles/ProductFeaturesTableStyles";

type featureTableProps = {
  features: Feature[];
  rowBgColorPattern?: "odd" | "even";
  HeadRow?: React.ReactNode;
  hasNoBorder: boolean;
};

const ProductFeaturesTable = ({
  features,
  rowBgColorPattern = "odd",
  HeadRow,
  hasNoBorder
}: featureTableProps) => {
  return (
    <Table hasNoBorder={hasNoBorder} rowBgColorPattern={rowBgColorPattern}>
      {HeadRow && <Table.Head>{HeadRow}</Table.Head>}
      <Table.Body>
        {features.map(({ name, values }, index) => (
          <Table.Row
            key={`feat-row-${name}--${index}`}
            data-testid="classification-feature"
          >
            <Table.Cell align="left" data-testid="classification-feature-name">
              {name}
            </Table.Cell>
            <Table.Cell align="right">
              {values.map((value) => (
                <FeatureValue
                  variant="body1"
                  data-testid="classification-feature-value"
                  key={replaceSpaces(`${name}-${value}`)}
                >
                  {value}
                </FeatureValue>
              ))}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default ProductFeaturesTable;
